import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    adminToken: localStorage.getItem('admin_token') || '',
    adminUser: JSON.parse(localStorage.getItem('admin_user') || 'null'),
    userToken: localStorage.getItem('user_token') || '',
    userInfo: JSON.parse(localStorage.getItem('user_info') || 'null'),
    unlockedArticles: JSON.parse(localStorage.getItem('unlocked_articles') || '[]')
  },

  getters: {
    isAdminLoggedIn: state => !!state.adminToken,
    isUserLoggedIn: state => !!state.userToken,
    userPoints: state => (state.userInfo ? state.userInfo.points : 0),
    hasUnlocked: state => id => state.unlockedArticles.includes(Number(id)),
    isArticleAccessible: (state, getters) => (article) => {
      if (!article) return false
      if (article.type === 'free') return true
      if (!getters.isUserLoggedIn) return false
      return getters.hasUnlocked(article.id)
    }
  },

  mutations: {
    SET_ADMIN_AUTH(state, { token, user }) {
      state.adminToken = token
      state.adminUser = user
      localStorage.setItem('admin_token', token)
      localStorage.setItem('admin_user', JSON.stringify(user))
    },
    CLEAR_ADMIN_AUTH(state) {
      state.adminToken = ''
      state.adminUser = null
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user')
    },
    SET_USER_AUTH(state, { token, user }) {
      state.userToken = token
      state.userInfo = user
      localStorage.setItem('user_token', token)
      localStorage.setItem('user_info', JSON.stringify(user))
    },
    UPDATE_USER_INFO(state, user) {
      state.userInfo = user
      localStorage.setItem('user_info', JSON.stringify(user))
    },
    UPDATE_USER_POINTS(state, points) {
      if (state.userInfo) {
        state.userInfo = { ...state.userInfo, points }
        localStorage.setItem('user_info', JSON.stringify(state.userInfo))
      }
    },
    CLEAR_USER_AUTH(state) {
      state.userToken = ''
      state.userInfo = null
      localStorage.removeItem('user_token')
      localStorage.removeItem('user_info')
    },
    ADD_UNLOCKED(state, articleId) {
      const id = Number(articleId)
      if (!state.unlockedArticles.includes(id)) {
        state.unlockedArticles.push(id)
        localStorage.setItem('unlocked_articles', JSON.stringify(state.unlockedArticles))
      }
    },
    SET_UNLOCKED(state, ids) {
      state.unlockedArticles = (ids || []).map(Number)
      localStorage.setItem('unlocked_articles', JSON.stringify(state.unlockedArticles))
    }
  },

  actions: {
    loginAdmin({ commit }, payload) {
      commit('SET_ADMIN_AUTH', payload)
    },
    logoutAdmin({ commit }) {
      commit('CLEAR_ADMIN_AUTH')
    },
    async loginUser({ commit, dispatch }, payload) {
      commit('SET_USER_AUTH', payload)
      await dispatch('fetchUnlockedArticles')
    },
    async fetchUnlockedArticles({ commit, state }) {
      if (!state.userToken) return
      try {
        const { userApi } = await import('@/api')
        const ids = await userApi.getUnlockedArticles()
        commit('SET_UNLOCKED', ids)
      } catch (e) {
        // ignore
      }
    },
    logoutUser({ commit }) {
      commit('CLEAR_USER_AUTH')
      commit('SET_UNLOCKED', [])
    },
    updateUserInfo({ commit }, user) {
      commit('UPDATE_USER_INFO', user)
    },
    updateUserPoints({ commit }, points) {
      commit('UPDATE_USER_POINTS', points)
    },
    unlockArticle({ commit }, articleId) {
      commit('ADD_UNLOCKED', articleId)
    }
  }
})
